<template>
  <div>
    <!-- 확장된 팝업 -->
    <transition name="slide-fade">
      <div v-if="showPopup" class="floating-popup expanded">
        <button class="close-btn" @click="togglePopup">
          <i class="fa fa-times"></i>
        </button>

        <div class="popup-header">
          <div class="pulse-dot"></div>
          <span>실시간 상담 가능</span>
        </div>

        <div class="popup-item phone-item" @click="callPhone">
          <div class="item-icon">
            <i class="fa fa-phone" style="line-height: 1;"></i>
          </div>
          <div class="item-content">
            <h4>DB구매 문의</h4>
            <p class="phone-number">0507-2097-1711</p>
            <span class="sub-text">24시간 상담가능</span>
          </div>
        </div>

        <div class="popup-item kakao-item" @click="GetKakaoChat">
          <div class="kakao-button">
            <i class="fa fa-comment" style="font-size: 24px; color: #3c1e1e;"></i>
            <span>카카오톡 상담</span>
          </div>
        </div>
      </div>
    </transition>

    <!-- 축소된 버튼 -->
    <transition name="fade">
      <div v-if="!showPopup" class="floating-popup collapsed" @click="togglePopup">
        <div class="collapsed-content">
          <div class="icon-stack">
            <i class="fa fa-comments" style="line-height: 1;"></i>
          </div>
          <span class="badge">DB문의</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "KakaoPopup",
  mounted() {
    this.checkPopupState();
  },
  data(){
    return {
      showPopup: false,
      hasInteracted: false
    }
  },
  methods:{
    togglePopup() {
      this.showPopup = !this.showPopup;
      this.hasInteracted = true;
      if (!this.showPopup) {
        localStorage.setItem('popupClosed', 'true');
      }
    },
    callPhone() {
      window.location.href = 'tel:0507-2097-1711';
    },
    goToLicense() {
      this.$router.push('/license');
    },
    GetKakaoChat(){
      window.open('https://open.kakao.com/o/sELYpF0h', 'kakaoChannel', 'width=1000, height=640')
    },
    checkPopupState() {
      const popupClosed = localStorage.getItem('popupClosed');
      if (popupClosed !== 'true') {
        this.showPopup = false;
      }
    }
  }
}
</script>

<style scoped>
/* 플로팅 팝업 기본 스타일 */
.floating-popup {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 9999;
  filter: drop-shadow(0 5px 20px rgba(0,0,0,0.15));
}

/* 확장된 팝업 */
.floating-popup.expanded {
  width: 320px;
  background: white;
  border-radius: 20px;
  padding: 20px;
  animation: slideUp 0.5s ease;
}

/* 닫기 버튼 */
.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 30px;
  height: 30px;
  border: none;
  background: #f0f0f0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  color: #666;
}

.close-btn:hover {
  background: #e0e0e0;
  transform: rotate(90deg);
}

/* 팝업 헤더 */
.popup-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.pulse-dot {
  width: 10px;
  height: 10px;
  background: #28a745;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
  }
}

.popup-header span {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

/* 팝업 아이템 */
.popup-item {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px;
  margin-bottom: 10px;
  background: #f8f9fa;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s;
}

.popup-item:hover {
  background: linear-gradient(135deg, #e7f3ff 0%, #f0f8ff 100%);
  transform: translateX(-5px);
}

.item-icon {
  width: 45px;
  height: 45px;
  background: linear-gradient(135deg, #1e90ff 0%, #4169e1 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  flex-shrink: 0;
}

.item-icon i {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.item-content h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.phone-number {
  margin: 5px 0;
  font-size: 18px;
  font-weight: 700;
  color: #1e90ff;
}

.sub-text {
  font-size: 12px;
  color: #999;
}

/* 카카오톡 버튼 */
.kakao-item {
  background: #fee500;
  padding: 12px;
}

.kakao-item:hover {
  background: #fdd835;
}

.kakao-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
}

.kakao-button i {
  display: flex;
  align-items: center;
  justify-content: center;
}

.kakao-button span {
  font-weight: 600;
  color: #3c1e1e;
  font-size: 15px;
}

/* 축소된 버튼 */
.floating-popup.collapsed {
  width: 70px;
  height: 70px;
  background: white;
  border: 2px solid #e7f3ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  animation: bounce 2s infinite;
  transition: all 0.3s;
  box-shadow: 0 5px 20px rgba(0,0,0,0.15);
}

.floating-popup.collapsed:hover {
  transform: scale(1.1);
  box-shadow: 0 10px 30px rgba(30,144,255,0.3);
  border-color: #1e90ff;
}

.collapsed-content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  width: 100%;
  height: 100%;
}

.icon-stack {
  color: #1e90ff;
  font-size: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.icon-stack i {
  display: flex;
  align-items: center;
  justify-content: center;
}

.badge {
  position: absolute;
  top: -35px;
  background: #ff4757;
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  animation: shake 3s infinite;
}

/* 애니메이션 */
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

@keyframes shake {
  0%, 90%, 100% {
    transform: translateX(0);
  }
  92%, 96% {
    transform: translateX(-3px);
  }
  94%, 98% {
    transform: translateX(3px);
  }
}

/* 트랜지션 */
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(20px);
  opacity: 0;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* 반응형 */
@media (max-width: 768px) {
  .floating-popup {
    bottom: 20px;
    right: 20px;
  }

  .floating-popup.expanded {
    width: 280px;
    padding: 15px;
  }

  .floating-popup.collapsed {
    width: 60px;
    height: 60px;
  }

  .icon-stack {
    font-size: 24px;
  }
}

/* 모든 화면 크기에서 표시 */
.floating-popup {
  display: block !important;
}
</style>